import { LandingPageBase } from '../landing-page-base/landing-page-base.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-guid-closed',
    templateUrl: './guid-closed.component.html',
    styleUrls: ['./guid-closed.component.css'],
    standalone: true,
    imports: [MatCardModule, MatButtonModule, CommonModule, LandingPageBase]
})
export class GuidClosed {
    headerText: string = 'Account Closed';
    contentText: string = 'Your online registration account has been closed. If you believe a mistake has been made please contact xxxxxxx.';

    constructor() {
    }

    ngOnInit(): void {
    }
}
